import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative grow" }

import CallOrMessageSupport from '@/components/ChatInterface/ContactSupport/CallOrMessageSupport.vue';
import EmailSupport from '@/components/ChatInterface/ContactSupport/EmailSupport.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactSupportUi',
  setup(__props) {


const utilStore = useStore.util;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["overflow-y-scroll", [
        _unref(utilStore).notification ? 'h-90' : 'h-104',
      ]])
    }, [
      (_unref(utilStore).supportId === 3)
        ? (_openBlock(), _createBlock(EmailSupport, { key: 0 }))
        : (_openBlock(), _createBlock(CallOrMessageSupport, { key: 1 }))
    ], 2)
  ]))
}
}

})